/* theme.js — Cart API, Section Rendering */

(function() {
  'use strict';

/* ===== Shopify money format ===== */
  if (!window.Shopify) window.Shopify = {};

  /* window.themeMoneyFormat is set from shop.money_format in layout/theme.liquid. */
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || window.themeMoneyFormat || '${{amount}}';

    function group(number, decimals, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      const value = (number / 100).toFixed(decimals);
      const parts = value.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return decimals && parts[1] ? dollars + decimal + parts[1] : dollars;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(match, name) {
      switch (name) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return match;
      }
    });
  };

  /* ===== Cart API ===== */
  let cartUpdateController = null;
  window.updateCartItem = async function(key, quantity) {
    /* ── GUARD: Fee items (Embroidery) — khách không thể chỉnh trực tiếp ──
       Fee item qty đồng bộ tự động khi sản phẩm chính thay đổi qty.
       Chỉ cho phép xóa (qty=0) — xóa fee item sẽ xóa cả nhóm _pz. */
    var feeEl = document.querySelector('[data-cart-item="' + key + '"][data-fee-item]');
    if (feeEl && quantity !== 0) {
      console.warn('[cart] Fee item qty syncs with main product. Change the main product quantity instead.');
      return;
    }

    if (cartUpdateController) cartUpdateController.abort();
    cartUpdateController = new AbortController();
    var signal = cartUpdateController.signal;
    window.dispatchEvent(new CustomEvent('cart-loading'));
    try {
      /* ── 1. Fetch cart để tìm fee items liên kết qua _pz ── */
      var linkedKeys = []; // keys of fee items to also update
      try {
        var cartRes = await fetch('/cart.js', { signal: signal });
        var cart = await cartRes.json();
        var currentItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].key) === String(key)) {
            currentItem = cart.items[i]; break;
          }
        }
        if (currentItem && currentItem.properties && currentItem.properties._pz) {
          var pzGroup = currentItem.properties._pz;
          var isFee = !!currentItem.properties._Embroidery;
          if (!isFee) {
            /* Main product → tìm fee items cùng _pz group */
            for (var j = 0; j < cart.items.length; j++) {
              var it = cart.items[j];
              if (it.key !== key && it.properties && it.properties._pz === pzGroup && it.properties._Embroidery) {
                linkedKeys.push(it.key);
              }
            }
          } else if (quantity === 0) {
            /* Xóa fee item → xóa toàn bộ nhóm _pz (main + all fees) */
            for (var j = 0; j < cart.items.length; j++) {
              var it = cart.items[j];
              if (it.key !== key && it.properties && it.properties._pz === pzGroup) {
                linkedKeys.push(it.key);
              }
            }
          }
        }
      } catch (cartErr) {
        if (cartErr.name === 'AbortError') throw cartErr;
        console.warn('[cart] Could not check linked items:', cartErr);
      }

      /* ── 2. Optimistic UI: ẩn items ngay khi xóa ── */
      if (quantity === 0) {
        var allKeys = [key].concat(linkedKeys);
        allKeys.forEach(function(k) {
          var el = document.querySelector('[data-cart-item="' + k + '"]');
          if (el) {
            el.style.transition = 'opacity 0.15s, max-height 0.2s';
            el.style.opacity = '0';
            el.style.overflow = 'hidden';
            el.style.maxHeight = el.offsetHeight + 'px';
            setTimeout(function() { el.style.maxHeight = '0'; el.style.padding = '0'; el.style.margin = '0'; }, 50);
          }
        });
      }

      /* ── 3. Update sản phẩm chính ── */
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
        signal: signal
      });
      if (!res.ok) throw new Error('Cart update failed');

      /* ── 4. Đồng bộ fee items liên kết (cùng _pz group) ── */
      for (var k = 0; k < linkedKeys.length; k++) {
        var feeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: linkedKeys[k], quantity: quantity }),
          signal: signal
        });
        if (!feeRes.ok) console.warn('[cart] Fee item sync failed for key:', linkedKeys[k]);
      }

      /* ── 5. Refresh cart drawer ── */
      await refreshCart();
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('Cart update failed:', e);
      window.dispatchEvent(new CustomEvent('cart-ready'));
    }
  };

  window.updateCartNote = async function(note) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
      if (!res.ok) throw new Error('Cart note update failed');
    } catch (e) {
      console.error('Cart note update failed:', e);
    }
  };

  async function refreshCart() {
    window.dispatchEvent(new CustomEvent('cart-loading'));
    try {
      // Run all fetches in parallel for speed
      const cartPageEl = document.querySelector('[data-cart-page]');
      const fetches = [
        fetch('/cart.js').then(function(r) { if (!r.ok) throw new Error('Cart fetch failed'); return r.json(); }),
        fetch('/?section_id=cart-drawer').then(function(r) { if (!r.ok) throw new Error('Cart drawer fetch failed'); return r.text(); })
      ];
      if (cartPageEl) {
        const sectionId = cartPageEl.getAttribute('data-section-id');
        fetches.push(fetch('/cart?section_id=' + sectionId).then(function(r) { if (!r.ok) throw new Error('Cart page fetch failed'); return r.text(); }));
      }
      const results = await Promise.all(fetches);
      const cartData = results[0];
      const html = results[1];

      // Update cart count badge
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) {
        el.textContent = cartData.item_count;
        el.classList.toggle('hidden', cartData.item_count === 0);
      });
      // Re-render cart drawer via section rendering API
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      // Update drawer body (line items, shipping progress)
      const drawerEl = document.querySelector('[data-drawer-cart]');
      if (drawerEl) {
        const newContent = doc.querySelector('[data-drawer-cart]');
        if (newContent) drawerEl.innerHTML = newContent.innerHTML;
      }
      // Update drawer footer (subtotal, checkout button)
      const footerEl = document.querySelector('[data-drawer-footer]');
      const newFooter = doc.querySelector('[data-drawer-footer]');
      if (footerEl && newFooter) {
        footerEl.innerHTML = newFooter.innerHTML;
      } else if (footerEl && !newFooter) {
        footerEl.remove();
      } else if (!footerEl && newFooter && drawerEl) {
        drawerEl.parentElement.appendChild(newFooter);
      }
      // Re-render main cart page if present
      if (cartPageEl && results[2]) {
        const cartDoc = new DOMParser().parseFromString(results[2], 'text/html');
        const newCartPage = cartDoc.querySelector('[data-cart-page]');
        if (newCartPage) cartPageEl.innerHTML = newCartPage.innerHTML;
      }
      // Hand the cart we just fetched to cart-ready listeners so they don't refetch it.
      window.dispatchEvent(new CustomEvent('cart-ready', { detail: { cart: cartData } }));
      return;
    } catch (e) {
      console.error('Cart refresh failed:', e);
    }
    window.dispatchEvent(new CustomEvent('cart-ready'));
  }

  /* ===== Add to Cart (intercept form) =====
     PERSONALIZE PATCH: cũng thêm các product phí ẩn (Text/Icon/Logo) như line item
     phụ, và hỗ trợ upload file logo (multipart). Xem snippet 'product-embroidery-personalizer'. */
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (!form.hasAttribute('data-product-form')) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const data = {};
      const properties = {};
      formData.forEach(function(value, key) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) {
          properties[match[1]] = value;
        } else {
          data[key] = value;
        }
      });

      /* ── FIX v2: Đọc qty từ Alpine data (immune to Customily app block DOM modifications) ──
         Customily app block scripts (loaded via content_for_header) can reset
         #product-qty input value to 1 before theme handlers read it.
         Alpine.$data() reads the reactive state directly, bypassing DOM. */
      const qtyInput = form.querySelector('#product-qty');
      let qty = 1;
      if (qtyInput) { try { const _ae = qtyInput.closest('[x-data]'); if (_ae && typeof Alpine !== 'undefined') { const _ad = Alpine.$data(_ae); if (_ad && typeof _ad.qty === 'number' && _ad.qty >= 1) { qty = _ad.qty; } else { qty = parseInt(qtyInput.value, 10) || 1; } } else { qty = parseInt(qtyInput.value, 10) || 1; } } catch (ex) { qty = parseInt(qtyInput.value, 10) || 1; } } else { qty = parseInt(data.quantity, 10) || 1; }

      const item = { id: parseInt(data.id), quantity: qty };
      if (Object.keys(properties).length > 0) item.properties = properties;

      /* ── Personalize: line item phí phụ (Text / Icon / Logo) ── */
      let extraItems = [];
      const feesEl = form.querySelector('[data-personalize-fees]');
      if (feesEl) {
        try { extraItems = JSON.parse(feesEl.textContent || '[]') || []; } catch (err) { extraItems = []; }
      }
      // Bỏ item chưa cấu hình variant id (còn "REPLACE_..."), ép kiểu số, đồng bộ số lượng
      extraItems = extraItems.filter(function(it) {
        return it && it.id && String(it.id).indexOf('REPLACE_') === -1;
      });
      extraItems.forEach(function(it) {
        it.id = parseInt(it.id, 10);
        if (!it.quantity) it.quantity = 1;
      });

      /* ── Personalize: nếu có file logo → phải add bằng multipart ── */
      const fileInput = form.querySelector('input[type="file"][name^="properties"]');
      const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

      // Open drawer + show loading immediately
      window.dispatchEvent(new CustomEvent('cart-loading'));
      window.dispatchEvent(new CustomEvent('cart-drawer-open'));

      // 1) Sản phẩm CHÍNH trước (tách riêng để phí phụ có lỗi cũng KHÔNG chặn sản phẩm chính)
      if (hasFile) {
        /* FIX: Đảm bảo FormData gửi đúng quantity khi upload file */
        formData.set('quantity', String(qty));
        const mainRes = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!mainRes.ok) throw new Error('Add to cart failed');
      } else {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!addRes.ok) throw new Error('Add to cart failed');
      }

      // 2) Phí phụ (Text/Icon/Logo) — best-effort, không chặn nếu lỗi
      if (extraItems.length) {
        try {
          const feeRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: extraItems })
          });
          if (!feeRes.ok) console.warn('Personalize fee add failed:', await feeRes.text());
        } catch (feeErr) { console.warn('Personalize fee add error:', feeErr); }
      }

      await refreshCart();

      /* ── Reset product-page qty selector back to 1 after successful add ──
         Without this, Alpine state keeps the old qty (e.g. 2) while Customily
         or a page re-render resets the DOM input to 1 — the display and the
         internal state drift apart, and the next +/− click jumps. */
      if (qtyInput) {
        try {
          var _ae = qtyInput.closest('[x-data]');
          if (_ae && typeof Alpine !== 'undefined') {
            Alpine.$data(_ae).qty = 1;
          }
        } catch (ex) { /* best effort */ }
      }
    } catch (e) {
      console.error('Add to cart failed:', e);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

/* ===== Sort handling ===== */
  window.handleSort = function(value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    window.location.href = url.toString();
  };

  /* ===== Sliders: native scroll-snap first, Embla where it cannot reach =====
     snapSlider: the markup lays the slides out itself (Tailwind widths +
     snap-start inside an overflow-x track, x-ref="track", which must be
     `relative` so slide offsetLeft is measured against it). This component only
     mirrors scroll state for arrows/dots. Arrows move a page (or one slide)
     at a time and rewind at either end; swiping stops at the ends. Touch and trackpads scroll
     the track natively; a mouse does not, so mouse drag is added here.
     emblaSlider: loop / autoplay, which scroll-snap has no answer for.
     Embla's api lives in a closure, not on the component, so Alpine never wraps
     it in a reactive proxy. Both register before Alpine starts (theme.js loads
     first) and Alpine tears them down when the theme editor swaps a section. */
  /* Loads a script once; resolves when it has run (an existing tag for the same src is reused). */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var found = document.querySelector('script[src="' + src + '"]');
      if (found && found.__loaded) { resolve(); return; }
      var s = found || document.createElement('script');
      s.addEventListener('load', function () { s.__loaded = true; resolve(); });
      s.addEventListener('error', reject);
      if (!found) { s.src = src; s.async = true; document.head.appendChild(s); }
    });
  }

  /* A link or image inside a slider would otherwise start the browser's own
     drag-and-drop, which cancels the pointer stream mid-drag. */
  function preventNativeDrag(e) {
    if (e.target.closest && e.target.closest('a, img')) e.preventDefault();
  }

  /* Grab / grabbing cursor on an Embla viewport, mouse only, and only while
     there is more than one snap to move between. */
  function grabCursor(viewport, api) {
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    var set = function () { viewport.style.cursor = api.scrollSnapList().length > 1 ? 'grab' : ''; };
    api.on('reInit', set);
    api.on('pointerDown', function () { if (api.scrollSnapList().length > 1) viewport.style.cursor = 'grabbing'; });
    api.on('pointerUp', set);
    set();
  }

  document.addEventListener('alpine:init', function () {
    /* opts: { rewind (default true), step: 'page' (default) | 'slide' }.
       A page is as many slides as fit whole in the track (perView, at least 1),
       the way Splide counted pages from perPage, so a 67% peek slider gets one
       dot per card and a 5-per-view row one dot per 5 cards. step 'slide' moves
       one card per arrow click (Splide's focus:center behaviour). Each slide's
       resting position follows its own scroll-snap-align (start or center), so
       arrows, dots, drag and the browser's own snap all land on the same spots. */
    Alpine.data('snapSlider', function (opts) {
      opts = opts || {};
      var ro = null;
      var restoreTimer = 0;
      /* Splide honoured prefers-reduced-motion (speed 0); so do arrows and dots here. */
      var motion = function () {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      };
      return {
        index: 0,
        count: 0,
        perView: 1,
        page: 0,
        pages: 1,
        atStart: true,
        atEnd: false,
        overflows: false,
        /* Scroll position at which slide i rests. */
        snapPos: function (i) {
          var track = this.$refs.track;
          var slides = track.children;
          if (!slides[i]) return 0;
          var max = track.scrollWidth - track.clientWidth;
          var pos = slides[i].offsetLeft - slides[0].offsetLeft;
          if (getComputedStyle(slides[i]).scrollSnapAlign.indexOf('center') !== -1) {
            pos -= (track.clientWidth - slides[i].offsetWidth) / 2;
          }
          return Math.max(0, Math.min(max, pos));
        },
        nearest: function (x) {
          var best = 0, bestD = Infinity;
          for (var i = 0; i < this.$refs.track.children.length; i++) {
            var d = Math.abs(this.snapPos(i) - x);
            if (d < bestD) { bestD = d; best = i; }
          }
          return best;
        },
        init: function () {
          var self = this;
          var track = this.$refs.track;
          var root = this.$root;
          var raf = 0;
          var drag = null;
          var swallowClick = false;
          /* Grab cursor only for a real mouse; touch screens never show it. */
          var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

          /* The carousel semantics Splide put on its root. */
          if (!root.hasAttribute('role')) root.setAttribute('role', 'region');
          if (!root.hasAttribute('aria-roledescription')) root.setAttribute('aria-roledescription', 'carousel');
          if (!root.hasAttribute('aria-label') && track.getAttribute('aria-label')) root.setAttribute('aria-label', track.getAttribute('aria-label'));

          function update() {
            raf = 0;
            var slides = track.children;
            var x = track.scrollLeft;
            var w = track.clientWidth;
            var max = track.scrollWidth - w;
            self.count = slides.length;
            /* A track that is overflow-hidden at this breakpoint (a static row
               on desktop) is not a slider there, even if its content is wider. */
            var ox = getComputedStyle(track).overflowX;
            self.overflows = max > 1 && (ox === 'auto' || ox === 'scroll');
            if (!drag || !drag.moved) track.style.cursor = self.overflows && finePointer ? 'grab' : '';
            self.atStart = x <= 1;
            self.atEnd = x >= max - 1;
            var stride = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : (slides[0] ? slides[0].offsetWidth : 0);
            self.perView = stride > 0 ? Math.max(1, Math.floor(w / stride + 0.02)) : 1;
            self.index = self.nearest(x);
            self.pages = self.overflows ? Math.ceil((self.count - self.perView) / self.perView) + 1 : 1;
            self.page = self.atEnd ? self.pages - 1 : Math.min(self.pages - 1, Math.round(self.index / self.perView));
          }
          this._schedule = function () { if (!raf) raf = requestAnimationFrame(update); };
          track.addEventListener('scroll', this._schedule, { passive: true });
          /* Also covers a track that starts inside display:none (shop-by-print
             tabs): it measures 0 until shown, then the observer fires. */
          ro = new ResizeObserver(this._schedule);
          ro.observe(track);
          update();

          /* Mouse drag. Snap is switched off while dragging (otherwise the
             browser re-snaps on every scrollLeft write), then the track settles
             on the nearest slide, biased in the drag direction. A drag swallows
             the click that follows so a card link does not open. */
          function endDrag() {
            track.style.userSelect = '';
            track.style.cursor = self.overflows && finePointer ? 'grab' : '';
          }
          this._down = function (e) {
            swallowClick = false;
            if (e.pointerType !== 'mouse' || e.button !== 0 || !self.overflows) return;
            if (e.target.closest('input, select, textarea, button')) return;
            drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
          };
          this._move = function (e) {
            if (!drag) return;
            /* Button released outside the track: this is a hover, not a drag. */
            if (!(e.buttons & 1)) {
              var was = drag.moved;
              drag = null;
              if (was) { endDrag(); track.style.scrollSnapType = ''; }
              return;
            }
            var dx = e.clientX - drag.x;
            if (!drag.moved) {
              if (Math.abs(dx) < 5) return;
              drag.moved = true;
              clearTimeout(restoreTimer);
              try { track.setPointerCapture(drag.id); } catch (err) {}
              track.style.scrollSnapType = 'none';
              track.style.scrollBehavior = 'auto';
              track.style.userSelect = 'none';
              track.style.cursor = 'grabbing';
            }
            track.scrollLeft = drag.left - dx;
          };
          this._up = function () {
            if (!drag) return;
            var d = drag;
            drag = null;
            if (!d.moved) return;
            swallowClick = true;
            endDrag();
            var dir = track.scrollLeft > d.left ? 1 : -1;
            var first = track.children[0];
            var aim = track.scrollLeft + dir * (first ? first.offsetWidth : 0) * 0.3;
            var from = self.nearest(d.left);
            var to = self.nearest(aim);
            /* A short drag (40px, as Embla/Splide count a swipe) already moves one
               slide; wide slides would otherwise need a third of their width. */
            if (to === from && Math.abs(track.scrollLeft - d.left) > 40) {
              to = Math.max(0, Math.min(track.children.length - 1, from + dir));
            }
            var target = self.snapPos(to);
            track.style.scrollBehavior = '';
            track.scrollTo({ left: target, behavior: motion() });
            /* Restore snap once the smooth scroll has landed. scrollend never
               fires when there is nothing left to scroll, so a timeout backs it up. */
            var restored = false;
            var restore = function () {
              if (restored) return;
              restored = true;
              clearTimeout(restoreTimer);
              track.removeEventListener('scrollend', restore);
              if (!drag || !drag.moved) track.style.scrollSnapType = '';
            };
            if (Math.abs(track.scrollLeft - target) < 1) { restore(); return; }
            if ('onscrollend' in window) track.addEventListener('scrollend', restore);
            restoreTimer = setTimeout(restore, 700);
          };
          this._click = function (e) {
            if (!swallowClick) return;
            swallowClick = false;
            e.preventDefault();
            e.stopPropagation();
          };
          track.addEventListener('pointerdown', this._down);
          track.addEventListener('pointermove', this._move);
          track.addEventListener('pointerup', this._up);
          track.addEventListener('pointercancel', this._up);
          track.addEventListener('click', this._click, true);
          track.addEventListener('dragstart', preventNativeDrag);
        },
        goTo: function (i) {
          if (!this.$refs.track.children[i]) return;
          this.$refs.track.scrollTo({ left: this.snapPos(i), behavior: motion() });
        },
        goPage: function (p) {
          this.goTo(Math.min(this.count - 1, p * this.perView));
        },
        next: function () {
          var track = this.$refs.track;
          if (this.atEnd) { if (opts.rewind !== false) track.scrollTo({ left: 0, behavior: motion() }); return; }
          this.goTo(Math.min(this.count - 1, this.index + (opts.step === 'slide' ? 1 : this.perView)));
        },
        prev: function () {
          var track = this.$refs.track;
          if (this.atStart) { if (opts.rewind !== false) track.scrollTo({ left: track.scrollWidth, behavior: motion() }); return; }
          this.goTo(Math.max(0, this.index - (opts.step === 'slide' ? 1 : this.perView)));
        },
        destroy: function () {
          var track = this.$refs.track;
          clearTimeout(restoreTimer);
          if (ro) ro.disconnect();
          track.removeEventListener('scroll', this._schedule);
          track.removeEventListener('pointerdown', this._down);
          track.removeEventListener('pointermove', this._move);
          track.removeEventListener('pointerup', this._up);
          track.removeEventListener('pointercancel', this._up);
          track.removeEventListener('click', this._click, true);
          track.removeEventListener('dragstart', preventNativeDrag);
        }
      };
    });

    /* opts: { options: <Embla options>, autoplay: <delay ms>, pauseOnHover } */
    /* Embla is preloaded on product pages only (layout/theme.liquid); elsewhere the slider injects
       it from data-embla-src, plus Autoplay from data-embla-autoplay-src when it autoplays. */
    Alpine.data('emblaSlider', function (opts) {
      opts = opts || {};
      var api = null;
      return {
        index: 0,
        count: 0,
        canPrev: false,
        canNext: false,
        init: function () {
          var self = this;
          /* Splide paused autoplay for prefers-reduced-motion; Embla Autoplay already stops on focus-in. */
          var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
          var autoplay = !!opts.autoplay && !reduced;
          var srcs = [];
          if (typeof EmblaCarousel === 'undefined') srcs.push(this.$root.getAttribute('data-embla-src'));
          if (autoplay && typeof EmblaCarouselAutoplay === 'undefined') srcs.push(this.$root.getAttribute('data-embla-autoplay-src'));
          srcs.filter(Boolean).reduce(function (chain, src) {
            return chain.then(function () { return loadScript(src); });
          }, Promise.resolve()).then(function () {
            if (!api && self.$refs.viewport && typeof EmblaCarousel !== 'undefined') self.mount(autoplay);
          }).catch(function () {});
        },
        mount: function (autoplay) {
          var self = this;
          var plugins = [];
          if (autoplay && window.EmblaCarouselAutoplay) {
            plugins.push(EmblaCarouselAutoplay({ delay: opts.autoplay, stopOnInteraction: false, stopOnMouseEnter: !!opts.pauseOnHover }));
          }
          api = EmblaCarousel(this.$refs.viewport, opts.options || {}, plugins);
          this.$refs.viewport.addEventListener('dragstart', preventNativeDrag);
          if (!(opts.options && opts.options.watchDrag === false)) grabCursor(this.$refs.viewport, api);
          function sync() {
            self.index = api.selectedScrollSnap();
            self.count = api.scrollSnapList().length;
            self.canPrev = api.canScrollPrev();
            self.canNext = api.canScrollNext();
          }
          api.on('select', sync);
          api.on('reInit', sync);
          sync();
        },
        goTo: function (i) { if (api) api.scrollTo(i); },
        next: function () { if (api) api.scrollNext(); },
        prev: function () { if (api) api.scrollPrev(); },
        destroy: function () { if (api) { api.destroy(); api = null; } }
      };
    });
  });

  /* ===== Product card: swap main image on swatch hover ===== */
  /* Delegated on document so AJAX-injected cards (recommendations) work too. */
  (function() {
    /* Preload swatch variant images after page idle */
    (window.requestIdleCallback || function (cb) { setTimeout(cb, 200); })(function () {
      document.querySelectorAll('.js-swatch-dot[data-variant-image]').forEach(function (dot) {
        var img = new Image();
        img.src = dot.dataset.variantImage;
      });
    });

    function cardImage(dot) {
      var card = dot.closest('.group');
      return card ? card.querySelector('a > img:first-of-type') : null;
    }

    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest('.js-swatch-dot[data-variant-image]');
      if (!dot) return;
      var img = cardImage(dot);
      if (!img) return;
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.src;
        img.dataset.originalSrcset = img.srcset || '';
      }
      img.src = dot.dataset.variantImage;
      img.srcset = '';
    });

    document.addEventListener('mouseout', function (e) {
      var dot = e.target.closest('.js-swatch-dot[data-variant-image]');
      if (!dot) return;
      if (dot.contains(e.relatedTarget)) return;
      var img = cardImage(dot);
      if (!img || !img.dataset.originalSrc) return;
      img.src = img.dataset.originalSrc;
      img.srcset = img.dataset.originalSrcset;
    });
  })();

  /* ===== Collections tab: closed panels are fetched, not rendered =====
     sections/tabbed-collection-grids.liquid renders only its first panel; the others
     carry data-ctab-url (sections/collection-product-cards.liquid for that tab's collection).
     They are filled when the section nears the screen after window load, or
     earlier when a tab button is hovered, focused or tapped. */
  (function () {
    function fill(panel) {
      if (!panel || !panel.dataset.ctabUrl || panel._ctabLoading) return;
      panel._ctabLoading = true;
      fetch(panel.dataset.ctabUrl)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          var root = tpl.content.querySelector('.shopify-section') || tpl.content;
          var count = parseInt(panel.dataset.ctabCount, 10) || root.children.length;
          var cards = [].slice.call(root.children, 0, count);
          if (!cards.length) return;
          panel.replaceChildren.apply(panel, cards);
          panel.removeAttribute('data-ctab-url');
          /* This theme swaps deferred and hover images once, at window load; cards that arrive
             later get their real src here (before load, the load-time pass still catches them). */
          if (document.readyState === 'complete') {
            panel.querySelectorAll('[data-defer-src], [data-hover-src]').forEach(function (img) {
              ['defer', 'hover'].forEach(function (k) {
                var src = img.getAttribute('data-' + k + '-src');
                var set = img.getAttribute('data-' + k + '-srcset');
                if (src) { img.setAttribute('src', src); img.removeAttribute('data-' + k + '-src'); }
                if (set) { img.setAttribute('srcset', set); img.removeAttribute('data-' + k + '-srcset'); }
              });
            });
          }
        })
        .catch(function () { panel._ctabLoading = false; });
    }

    ['pointerover', 'focusin', 'click'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var btn = e.target.closest && e.target.closest('[data-ctab-target]');
        if (btn) fill(document.getElementById(btn.dataset.ctabTarget));
      }, { passive: true });
    });

    function watchSections() {
      var panels = document.querySelectorAll('[data-ctab-url]');
      if (!panels.length) return;
      if (!('IntersectionObserver' in window)) { panels.forEach(fill); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          entry.target.querySelectorAll('[data-ctab-url]').forEach(fill);
        });
      }, { rootMargin: '600px 0px' });
      var seen = [];
      panels.forEach(function (p) {
        var section = p.closest('section') || p.parentNode;
        if (seen.indexOf(section) === -1) { seen.push(section); io.observe(section); }
      });
    }
    if (document.readyState === 'complete') watchSections();
    else window.addEventListener('load', watchSections);
  })();

  /* ===== Deferred image loading =====
     Sections render below-the-fold images with data-defer-src(set) instead of
     src(set). After the window load event the browser has finished the critical
     resources; we then swap the attributes so these images start downloading.
     Images are grouped inside [data-defer-group] containers. */
  (function () {
    function activateImage(img) {
      var src = img.getAttribute('data-defer-src');
      var srcset = img.getAttribute('data-defer-srcset');
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-defer-src');
      }
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-defer-srcset');
      }
    }

    function activateGroup(group) {
      var imgs = group.querySelectorAll('[data-defer-src]');
      for (var i = 0; i < imgs.length; i++) activateImage(imgs[i]);
    }

    function activateAll() {
      var groups = document.querySelectorAll('[data-defer-group]');
      for (var i = 0; i < groups.length; i++) activateGroup(groups[i]);
      var stray = document.querySelectorAll('[data-defer-src]');
      for (var j = 0; j < stray.length; j++) activateImage(stray[j]);
    }

    if (document.readyState === 'complete') {
      activateAll();
    } else {
      window.addEventListener('load', activateAll);
    }
  })();

  /* ===== Hover image loading =====
     Product cards ship their secondary (hover) image as data-hover-src(set).
     We swap the attributes after the window load event so images are ready
     on both desktop (hover) and mobile (tap / swipe). */
  (function () {
    function activateHoverImages() {
      var imgs = document.querySelectorAll('[data-hover-src]');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var src = img.getAttribute('data-hover-src');
        var srcset = img.getAttribute('data-hover-srcset');
        if (src) {
          img.setAttribute('src', src);
          img.removeAttribute('data-hover-src');
        }
        if (srcset) {
          img.setAttribute('srcset', srcset);
          img.removeAttribute('data-hover-srcset');
        }
      }
    }

    if (document.readyState === 'complete') {
      activateHoverImages();
    } else {
      window.addEventListener('load', activateHoverImages);
    }
  })();
})();

/* ===== Swallow the click that ends a drag on an Embla carousel =====
   Splide swallowed the click after any mouse drag (touch: after 10px). Embla
   only does so past 10px, and only inside its own root, after capture
   listeners on ancestors (the PDP gallery's PhotoSwipe loader on
   #product-gallery) have already seen it: a short drag on a gallery image
   opened the lightbox. The click is stopped here, on window, first. */
(function () {
  var VIEWPORTS = '[x-ref="viewport"], [data-embla-viewport]';
  var start = null, swallow = null, timer = 0;
  function axisY(vp) {
    var c = vp.firstElementChild;
    return !!c && getComputedStyle(c).flexDirection.indexOf('column') === 0;
  }
  window.addEventListener('pointerdown', function (e) {
    swallow = null;
    var vp = e.target.closest && e.target.closest(VIEWPORTS);
    start = vp ? { vp: vp, y: axisY(vp), x0: e.clientX, y0: e.clientY, touch: e.pointerType !== 'mouse', moved: 0 } : null;
  }, true);
  window.addEventListener('pointermove', function (e) {
    if (start) start.moved = Math.max(start.moved, Math.abs(start.y ? e.clientY - start.y0 : e.clientX - start.x0));
  }, { capture: true, passive: true });
  window.addEventListener('pointerup', function () {
    if (start && start.moved > (start.touch ? 10 : 0)) {
      swallow = start.vp;
      clearTimeout(timer);
      timer = setTimeout(function () { swallow = null; }, 400);
    }
    start = null;
  }, true);
  window.addEventListener('click', function (e) {
    if (!swallow || !swallow.contains(e.target)) return;
    swallow = null;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
